import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { SuccessIcon } from 'common/icons';
import { DefaultButton } from 'common/components';
import { withTheme } from 'common/styling/theme';
import Confetti from 'react-confetti';
import { useHistory } from 'react-router-dom';
import { staticStyles, getDynamicStyles } from './style';

const PaymentSuccess = ({ isDeposit, theme }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  const history = useHistory();
  const ref = useRef();

  const [animated, setAnimated] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAnimated(false);
    }, 1500);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const handleRedirect = () => {
    if (isDeposit) {
      history.push('/');
    } else {
      history.push('/withdraw');
    }
  };

  return (
    <div className="PaymentsSuccess" ref={ref}>
      <Confetti
        width={ref.current?.clientWidth || 100}
        height={ref.current?.clientHeight || 100}
        numberOfPieces={animated ? 350 : 0}
      />
      <div className="PaymentsSuccess-icon">
        <SuccessIcon />
      </div>
      <FormattedMessage id={isDeposit ? 'depositSuccessfullyReceived' : 'transactionSuccessful'}>
        {txt => <h3 className="PaymentsSuccess__title">{txt}</h3>}
      </FormattedMessage>
      <FormattedMessage id={isDeposit ? 'yourFundsHaveBeenCredited' : 'yourPaymentHasBeenProcessedSecurely'}>
        {txt => <p className="PaymentsSuccess__message">{txt}</p>}
      </FormattedMessage>
      <DefaultButton textId={isDeposit ? 'clientStartTrade' : 'withdrawMore'} onClick={handleRedirect} />

      <style jsx global>
        {staticStyles}
      </style>
      <style jsx global>
        {dynamicStyles}
      </style>
    </div>
  );
};

PaymentSuccess.propTypes = {
  isDeposit: PropTypes.bool.isRequired,
  theme: PropTypes.object,
};

PaymentSuccess.defaultProps = {
  theme: {},
};

PaymentSuccess.defaultProps = {};

export default withTheme()(PaymentSuccess);
export { PaymentSuccess };
